import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';
import type { GetTimeTemplatesResponse, GetTimezonesResponse } from '../../../common/types/time';

const getTimezones = async (): Promise<{
	timezones: {
		currentOffset: number;
		id: string;
		lName: string;
		offset: number;
		simpleName: string;
		sName: string;
	}[];
}> => {
	const response = await fetch<GetTimezonesResponse>(urls.customers.timezones.url(), {
		method: 'GET',
	});

	const adjusted = response.timezones.map((timezone) => ({
		...timezone,
		offset: timezone.offset * 60000, // convert minutes to millis
		currentOffset: timezone.currentOffset * 60000, // convert minutes to millis
	}));

	return {
		...response,
		timezones: adjusted,
	};
};

const getTimeTemplates = (): Promise<GetTimeTemplatesResponse> => {
	return fetch<GetTimeTemplatesResponse>(urls.schedules.timeTemplates.rotation.url(), {
		method: 'GET',
	});
};

export const endpoints: {
	getTimeTemplates: () => Promise<GetTimeTemplatesResponse>;
	getTimezones: () => Promise<{
		timezones: {
			currentOffset: number;
			id: string;
			lName: string;
			offset: number;
			simpleName: string;
			sName: string;
		}[];
	}>;
} = {
	getTimezones,
	getTimeTemplates,
};
